import { QueryClient, UseMutationOptions, useMutation as useReactQueryMutation } from '@tanstack/react-query';

import { ApiResponse } from '../types/api';

type Props<TData = unknown, TVariables = void, TContext = unknown> = UseMutationOptions<
  TData,
  ApiResponse,
  TVariables,
  TContext
>;
function useMutation<TData = unknown, TVariables = void, TContext = unknown>(
  options: Props<TData, TVariables, TContext>,
  queryClient?: QueryClient,
) {
  return useReactQueryMutation(options, queryClient);
}

export default useMutation;
